/*
 * Shared "nothing selected yet" info banner for Deckorate's AI image feature
 * panels (Sketch to Slide, Photo Headshot, ...). Shows the live selection
 * error when there is one, otherwise the feature's own default prompt.
 */

export interface SelectionHintClassNames {
  readonly statusBox?: string;
  readonly statusInfo?: string;
  readonly statusText?: string;
}

export interface SelectionHintProps {
  readonly selectionError: string | null;
  readonly defaultMessage: string;
  readonly classNames: SelectionHintClassNames;
}

export function SelectionHint({ selectionError, defaultMessage, classNames }: Readonly<SelectionHintProps>) {
  return (
    <div className={`${classNames.statusBox} ${classNames.statusInfo}`}>
      <span className={classNames.statusText}>{selectionError ?? defaultMessage}</span>
    </div>
  );
}
